const careCategoryIconMap = {
  'doctor-visit': 'stethoscope',
  prescriptions: 'pills',
  'x-rays-imaging-radiology': 'imaging',
  'equipment-supplies': 'crutches',
  'lab-work': 'lab',
  surgery: 'surgery',
  medicine: 'needle',
  anesthesia: 'anesthesia',
  transportation: 'ambulance',
  'hospital-admission': 'hospital',
  'therapy-rehab': 'occupationalTherapy',
  'prosthetics-and-orthotics': 'foot',
  'maternity-care': 'pregnancy',
  maternity: 'pregnancy',
  fertility: 'pregnancy',
  'same-day-facility-services': 'hospital',
  correction: 'pencil',
  'non-covered': 'medkit',
}

/**
 * Converts a backend category (for a Sidecar code) or specialty (for a
 * provider) into a string that our Icon component can use.
 *
 * @param {string} categorySlug - Value provided by our backend.
 * @returns {string} Value our Icon component can use.
 */
export const getCareCategoryIcon = (categorySlug: string): string => {
  return careCategoryIconMap[categorySlug] || categorySlug || 'stethoscope'
}
